/* Colección: filtros y columnas (port del original; el catálogo ahora lo renderiza Shopify) */
(function(){
var colActiveCategory = 'todo';
var colActiveType = 'todos';

function colEsc(t){ return String(t).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
function colAnnounce(){
var st = document.getElementById('col-status');
if(!st) return;
var n = Array.prototype.filter.call(document.querySelectorAll('.col-card'), function(c){ return c.style.display !== 'none'; }).length;
var msg = n === 0 ? st.getAttribute('data-none') : (n === 1 ? st.getAttribute('data-one') : (st.getAttribute('data-many') || '').replace('{count}', n));
st.textContent = msg || '';
}
function colTypeKey(rawType){
return rawType;
}
var colLabels = {};
document.querySelectorAll('.col-card').forEach(function(c){ if(c.dataset.type) colLabels[c.dataset.type] = c.dataset.typeLabel || c.dataset.type; });

function colRenderSubfilters(){
var sub = document.getElementById('col-subfilters');
var cards = Array.from(document.querySelectorAll('.col-card'));
var visibleTypes = cards
.filter(function(c){ return colActiveCategory === 'todo' || c.dataset.category === colActiveCategory; })
.map(function(c){ return colTypeKey(c.dataset.type); });
var uniqueTypes = visibleTypes.filter(function(t,i){ return visibleTypes.indexOf(t) === i; });

if(uniqueTypes.length < 1){ sub.innerHTML = ''; colActiveType = 'todos'; return; }

var allLabel = sub.getAttribute('data-all-label') || 'Todos';
var html = '<button type="button" class="col-subfilter-btn active" aria-pressed="true" data-type="todos">'+colEsc(allLabel)+'</button>';
uniqueTypes.forEach(function(t){
html += '<button type="button" class="col-subfilter-btn" aria-pressed="false" data-type="'+colEsc(t)+'">'+colEsc(colLabels[t] || t)+'</button>';
});
sub.innerHTML = html;
colActiveType = 'todos';
}

function colApplyFilters(){
document.querySelectorAll('.col-card').forEach(function(card){
var matchCategory = colActiveCategory === 'todo' || card.dataset.category === colActiveCategory;
var matchType = colActiveType === 'todos' || colTypeKey(card.dataset.type) === colActiveType;
card.style.display = (matchCategory && matchType) ? '' : 'none';
});
var empty = document.getElementById('col-filter-empty');
var visibleCount = Array.prototype.filter.call(document.querySelectorAll('.col-card'), function(card){ return card.style.display !== 'none'; }).length;
if(empty) empty.hidden = visibleCount !== 0;
colRebalanceColumns();
}

function colRebalanceColumns(){
var colLeft = document.getElementById('col-grid-col-left');
var colRight = document.getElementById('col-grid-col-right');
var grid = document.getElementById('col-grid');
if(!colLeft || !colRight || !grid) return;
var visible = Array.prototype.slice.call(grid.querySelectorAll('.col-card:not(.col-card--wide)')).filter(function(c){
return c.style.display !== 'none';
});
var wides = Array.prototype.slice.call(grid.querySelectorAll('.col-card--wide'));
visible.forEach(function(card, i){
(i % 2 === 0 ? colLeft : colRight).appendChild(card);
});
colRight.classList.toggle('col-grid-col--offset-active', colLeft.children.length > 0 && colRight.children.length > 0);
wides.forEach(function(w){ grid.appendChild(w); });
}

document.getElementById('col-filters').addEventListener('click', function(e){
var btn = e.target.closest('.col-filter-btn');
if(!btn) return;
document.querySelectorAll('.col-filter-btn').forEach(function(b){b.classList.remove('active'); b.setAttribute('aria-pressed','false');});
btn.classList.add('active');
btn.setAttribute('aria-pressed','true');
colActiveCategory = btn.dataset.filter;
colRenderSubfilters();
colApplyFilters();
colAnnounce();
});

document.getElementById('col-subfilters').addEventListener('click', function(e){
var btn = e.target.closest('.col-subfilter-btn');
if(!btn) return;
document.querySelectorAll('.col-subfilter-btn').forEach(function(b){b.classList.remove('active'); b.setAttribute('aria-pressed','false');});
btn.classList.add('active');
btn.setAttribute('aria-pressed','true');
colActiveType = btn.dataset.type;
colApplyFilters();
colAnnounce();
});

/* Enlaces con ancla (#trekking, #playa, #camping, #hogar, #todo): aplican el filtro de categoría
   cuya clave (data-filter) coincide. Si la ancla no existe se muestra todo, igual que sin ancla. */
function colApplyHash(scroll){
var key = '';
try { key = decodeURIComponent(window.location.hash.replace('#','')).toLowerCase(); } catch(err) { key = ''; }
var btn = key ? document.querySelector('.col-filter-btn[data-filter="' + key + '"]') : null;
if(btn){
document.querySelectorAll('.col-filter-btn').forEach(function(b){b.classList.remove('active'); b.setAttribute('aria-pressed','false');});
btn.classList.add('active');
btn.setAttribute('aria-pressed','true');
colActiveCategory = key;
colRenderSubfilters();
colApplyFilters();
colAnnounce();
if(scroll) btn.scrollIntoView({block:'center'});
} else {
colRebalanceColumns();
}
}
colApplyHash(true);
window.addEventListener('hashchange', function(){ colApplyHash(false); });

})();
